import { useAuth } from "@flaminem/authentication";
import { FC } from "react";
import { Outlet } from "react-router-dom";

import { SpinnerFullPage } from "src/core/components/custom-ui/spinner-full-page";

/**
 * AuthGate :
 * Rôle fonctionnel :
 * - Garantir que l'utilisateur est authentifié avant d'accéder à l'application.
 * - Bloquer le rendu tant que la librairie d'authentification n'a pas fini son initialisation.
 *
 * Ce composant ne gère PAS la redirection vers le login :
 * celle-ci est entièrement déléguée à la librairie d'auth (@flaminem/authentication / Keycloak).
 *
 * Utilisation :
 * - Placé haut dans l'arbre des routes.
 * - Sert de "porte d'entrée" globale avant toute logique tenant ou applicative.
 */
export const AuthGate: FC = () => {
  const auth = useAuth();

  // Démarrage : on attend que la lib d'auth soit prête
  const isBootAuth = !auth.user && !auth.isAuthenticated;
  if (isBootAuth) return <SpinnerFullPage />;

  // Non authentifié : la redirection Keycloak est gérée par la lib -> on ne rend rien
  if (!auth.isAuthenticated) return null;

  return <Outlet />;
};
